import { forwardRef } from 'react'
import {
  type IntersectionOptions,
  useInView,
} from 'react-intersection-observer'

// I need to use a generic because I am wrapping components with Suspense
// TODO: compose hocs and create a withSuspense HOC
const withLazyLoad = <ComponentProps,>(
  Component: React.FC<ComponentProps>,
  config: IntersectionOptions,
) => {
  type WrapperComponentProps = ComponentProps & {
    id?: string
    className?: string
  }

  return forwardRef<typeof Component, WrapperComponentProps>(
    ({ id, ...otherProps }, compoRef) => {
      const [ref, inView] = useInView(config)

      return (
        <div ref={ref} id={id}>
          {/* // We need a cast because: //
          https://github.com/DefinitelyTyped/DefinitelyTyped/issues/32355 //
          https://github.com/Microsoft/TypeScript/issues/28938#issuecomment-450636046 */}
          {inView && (
            <Component {...(otherProps as ComponentProps)} ref={compoRef} />
          )}
        </div>
      )
    },
  )
}

export default withLazyLoad
